import { useState } from 'react'
import { CheckCircle } from 'lucide-react'
import { Button } from '@/common/ui/button'
import type { CryptoInvoiceData } from '@/modules/crypto-invoices/type'
import ConfirmTransactionModal from './ConfirmTransactionModal'

interface ConfirmTransactionButtonProps {
	invoice: CryptoInvoiceData
}

export default function ConfirmTransactionButton({
	invoice,
}: ConfirmTransactionButtonProps) {
	const [isOpen, setIsOpen] = useState(false)

	const isDisabled = invoice.status === 'COMPLETED' || !invoice.walletAddress

	return (
		<>
			<Button
				variant="default"
				size="sm"
				onClick={() => setIsOpen(true)}
				disabled={isDisabled}
			>
				<CheckCircle className="mr-2 h-4 w-4" />
				ยืนยัน
			</Button>
			<ConfirmTransactionModal
				invoice={invoice}
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
			/>
		</>
	)
}
